import styled from 'styled-components'

export const NavBarContainer = styled.div`
        background: var(--gray-200);
        height: 40px;

        .navbar-header {
            display: flex;
            align-items: center;
            flex-direction: row;
            height: 40px;
            gap: 20px;
            padding: 0;

            .navbar-header-item {
                padding: 10px 0;
                color: var(--blue-500);
                font-family: var(--font-bold);
                border-bottom: 2px solid var(--gray-200);
                cursor: pointer;

                &.active {
                    color: var(--gray-700);
                    border-bottom: 2px solid var(--blue-500);
                }
            }
        }
`
